module.exports = __webpack_public_path__ + "static/compass.821f4598.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/compass.svg
// module id = 420
// module chunks = 221427640695397